"use client";

import AssociatedProducts, {
  AssociatedProductsTypes,
} from "@/app/components/pages-components/common/associated-products/AssociatedProducts";
interface Props {
  slug: string;
}
const Related: React.FC<Props> = ({ slug }) => {
  return (
    <>
      <AssociatedProducts type={AssociatedProductsTypes.upsell} id={slug} />
      <AssociatedProducts type={AssociatedProductsTypes.related} id={slug} />
      <AssociatedProducts type={AssociatedProductsTypes.similar} id={slug} />
    </>
  );
};

export default Related;
